import React from 'react';
import { connect } from 'react-redux';
import DeliveryTarjetas from './DeliveryTarjetas';

import {
    getDatosDelivery,
    getPerfilByUserId,
    getPermisosPantalla,
    getSucursalesByUsuario,
    aplicarFiltros,
    toggleCheckAll,
    toggleCheckedRow,
    toggleCheckTipo,
    toggleTarjetaChecked,
    togglePinChecked,
    filterByEstado,
    filterByFechaProceso,
    searchInTable,
    cambiarEstadoProductos,
    RealziarBusquedaProductoFiltrada,
    cambiarRangoPagina
} from '../actions/Actions';

const mapStateToProps = (state) => {
    return {
        data: state.delivery
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getDatosDelivery: (currentScope) => {
            dispatch(getPermisosPantalla(currentScope));
            dispatch(getDatosDelivery());
            dispatch(getSucursalesByUsuario(currentScope.UserId));
            dispatch(getPerfilByUserId(currentScope));
        },
        toggleCheckAll: () => {
            dispatch(toggleCheckAll());
        },
        toggleCheckedRow: (row) => {
            dispatch(toggleCheckedRow(row));
        },
        toggleTarjetaChecked: () => {
            dispatch(toggleTarjetaChecked());
        },
        togglePinChecked: () => {
            dispatch(togglePinChecked());
        },
        toggleCheckTipo: (tipos) => {
            dispatch(toggleCheckTipo(tipos));
        },
        filterByEstado: (value) => {
            dispatch(filterByEstado(value));
        },
        searchInTable: (value, estado) => {
            dispatch(searchInTable(value, estado));
        },
        cambiarEstadoProductos(productos, estado) {
            dispatch(cambiarEstadoProductos(productos, estado));
        },
        filterByFechaProceso(proceso) {
            dispatch(filterByFechaProceso(proceso));
        },
        RealziarBusquedaProductoFiltrada(state) {
            dispatch(RealziarBusquedaProductoFiltrada(state));
        },
        cambiarRangoPagina(indexpagina) {
            dispatch(cambiarRangoPagina(indexpagina))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryTarjetas);
